import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { API_URLS } from '@app/utils/urls';
import { AskHelpAssistantRequest, AssistantAskResponse, AssistantTaxonomyResponse } from './help-assistant.types';

export * from './help-assistant.types';

@Injectable({ providedIn: 'root' })
export class HelpAssistantService {
  constructor(private readonly api: ApiService, private readonly router: Router) {}

  async getTaxonomy(): Promise<AssistantTaxonomyResponse> {
    const response = await this.api.get(API_URLS.HELP_ASSISTANT.TAXONOMY, new HttpParams());
    return response?.data as AssistantTaxonomyResponse;
  }

  async ask(request: AskHelpAssistantRequest): Promise<AssistantAskResponse> {
    const response = await this.api.post(
      API_URLS.HELP_ASSISTANT.ASK,
      { ...request, route: request.route ?? this.router.url },
      { headers: { 'X-Skip-Spinner': 'true' } },
    );
    return response?.data as AssistantAskResponse;
  }
}
